class YotpoStars extends HTMLElement {
  connectedCallback() {
    this.initialiseYotpoWidgets()

    this.addEventListener('click', this.handleClick)
  }

  initialiseYotpoWidgets(retryCount = 30) {
    if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
      window.yotpoWidgetsContainer.initWidgets()
      return
    }

    if (retryCount > 0) {
      window.setTimeout(() => this.initialiseYotpoWidgets(retryCount - 1), 200)
    }
  }

  handleClick() {
    window.location.href = `${this.productUrl}#yotpo-reviews-main-widget`;
  }

  get productUrl() {
    return this.getAttribute('product-url')
  }
}

if (!customElements.get('yotpo-stars')) {
  customElements.define('yotpo-stars', YotpoStars)
}
